import React, { useEffect, useState } from "react";
import { group } from "d3-array";
import { contourDensity } from "d3-contour";
import AnimatedHeatPath from "./common/AnimatedHeatPath";
import { clusterKeys } from "./common/utils";
import chroma from "chroma-js";


const Density = React.memo(({ data, xScale, yScale, showMap }) => {

    if (!showMap) {
        return null;
    }


    const [toggle, setToggle] = useState(false);

    const colors = ['rgb(10,100,150)', 'rgb(10,240,120)', 'yellow', 'rgb(240,10,10)']

    const color = chroma.scale(colors);
    useEffect(() => {
        setTimeout(() => {
            setToggle(true);
        });

    }, []);


    // get all the points for each cluster
    const clusters = group(data, d => d.cluster_id);

    //get cluster keys — dynamic count; do NOT assume exactly 4 clusters

    const uniqueClusterValues = clusterKeys(data);

    // The contour grid is in the pixel space emitted by the x/y accessors
    // below, so derive it from the scale ranges (not the data-domain max,
    // which broke whenever a cluster slot was absent:
    // clusters.get(undefined) -> undefined -> "not iterable").

    const gridWidth = Math.ceil(Math.max(...xScale.range()));
    const gridHeight = Math.ceil(Math.max(...yScale.range()));

    // create a contour for each cluster that is actually present

    const contours = uniqueClusterValues.flatMap(clusterValue => {
        const points = clusters.get(clusterValue);
        if (!points || points.length === 0) return [];

        return contourDensity()
            .x(d => xScale(d.x))
            .y(d => yScale(d.y))
            .size([gridWidth, gridHeight])
            .bandwidth(30)
            .thresholds(40)(points)
    });

    // using react animation
    // contours is always an array (flatMap), so no truthiness fallback is needed
    return (
        <g data-testid="Density">
            {contours.map((d, i) => {
                return (
                    <AnimatedHeatPath
                        key={d.id ?? i}
                        index={d}
                        toggle={toggle}
                    />
                )
            })}
        </g>
    );
}
);

export default Density;
